(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_buy-more-strip"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_filament-color-switcher"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

var morphPromise = null;
var loadMorph = function loadMorph() {
  if (!morphPromise) {
    morphPromise = new Function("return import('@theme/morph')")().then(function (mod) {
      return mod.morph;
    }).catch(function () {
      return null;
    });
  }
  return morphPromise;
};
var _modal = new WeakMap();
var _searchInput = new WeakMap();
var _modalGrid = new WeakMap();
var _modalEmpty = new WeakMap();
var _lastFocusedBeforeModal = new WeakMap();
var _swapAbort = new WeakMap();
var _onClick = new WeakMap();
var _onModalClick = new WeakMap();
var _onModalClose = new WeakMap();
var _FilamentColorSwitcher_brand = new WeakSet();
var _onSearchInput = new WeakMap();
var _onPopState = new WeakMap();
var FilamentColorSwitcher = function (_HTMLElement) {
  function FilamentColorSwitcher() {
    var _this;
    _classCallCheck(this, FilamentColorSwitcher);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilamentColorSwitcher, [].concat(args));
    _classPrivateMethodInitSpec(_this, _FilamentColorSwitcher_brand);
    _classPrivateFieldInitSpec(_this, _modal, null);
    _classPrivateFieldInitSpec(_this, _searchInput, null);
    _classPrivateFieldInitSpec(_this, _modalGrid, null);
    _classPrivateFieldInitSpec(_this, _modalEmpty, null);
    _classPrivateFieldInitSpec(_this, _lastFocusedBeforeModal, null);
    _classPrivateFieldInitSpec(_this, _swapAbort, null);
    _classPrivateFieldInitSpec(_this, _onClick, function (event) {
      var _event$target$closest, _event$target, _event$target$closest2, _event$target2, _event$target$closest3, _event$target3;
      var openTrigger = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, '[data-fcs-open-modal]');
      if (openTrigger && _this.contains(openTrigger)) {
        event.preventDefault();
        _assertClassBrand(_FilamentColorSwitcher_brand, _this, _openModal).call(_this);
        return;
      }
      var closeTrigger = (_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[data-fcs-close-modal]');
      if (closeTrigger) {
        event.preventDefault();
        _assertClassBrand(_FilamentColorSwitcher_brand, _this, _closeModal).call(_this);
        return;
      }
      var swatch = (_event$target$closest3 = (_event$target3 = event.target).closest) === null || _event$target$closest3 === void 0 ? void 0 : _event$target$closest3.call(_event$target3, '[data-fcs-swatch]');
      if (swatch && _this.contains(swatch)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
        if (swatch.classList.contains('is-active')) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        _assertClassBrand(_FilamentColorSwitcher_brand, _this, _swapToSibling).call(_this, swatch.href, swatch);
      }
    });
    _classPrivateFieldInitSpec(_this, _onModalClick, function (event) {
      if (event.target === _classPrivateFieldGet(_modal, _this)) _assertClassBrand(_FilamentColorSwitcher_brand, _this, _closeModal).call(_this);
    });
    _classPrivateFieldInitSpec(_this, _onModalClose, function () {
      document.body.style.removeProperty('overflow');
      if (_classPrivateFieldGet(_lastFocusedBeforeModal, _this) instanceof HTMLElement) {
        _classPrivateFieldGet(_lastFocusedBeforeModal, _this).focus();
      }
      _classPrivateFieldSet(_lastFocusedBeforeModal, _this, null);
      if (_classPrivateFieldGet(_searchInput, _this)) {
        _classPrivateFieldGet(_searchInput, _this).value = '';
        _assertClassBrand(_FilamentColorSwitcher_brand, _this, _filterSwatches).call(_this, '');
      }
    });
    _classPrivateFieldInitSpec(_this, _onSearchInput, function (event) {
      _assertClassBrand(_FilamentColorSwitcher_brand, _this, _filterSwatches).call(_this, event.target.value);
    });
    _classPrivateFieldInitSpec(_this, _onPopState, function () {
      var _document$querySelect;
      var activeHref = (_document$querySelect = document.querySelector('.filament-color-switcher__swatch.is-active')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('href');
      if (!activeHref) return;
      var activeUrl = new URL(activeHref, window.location.origin);
      if (activeUrl.pathname === window.location.pathname) return;
      _assertClassBrand(_FilamentColorSwitcher_brand, _this, _swapToSibling).call(_this, window.location.pathname + window.location.search, null);
    });
    return _this;
  }
  _inherits(FilamentColorSwitcher, _HTMLElement);
  return _createClass(FilamentColorSwitcher, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _classPrivateFieldSet(_modal, this, this.querySelector('[data-fcs-modal]'));
      _classPrivateFieldSet(_searchInput, this, this.querySelector('[data-fcs-search]'));
      _classPrivateFieldSet(_modalGrid, this, this.querySelector('[data-fcs-modal-grid]'));
      _classPrivateFieldSet(_modalEmpty, this, this.querySelector('[data-fcs-modal-empty]'));
      this.addEventListener('click', _classPrivateFieldGet(_onClick, this));
      if (_classPrivateFieldGet(_modal, this)) {
        _classPrivateFieldGet(_modal, this).addEventListener('click', _classPrivateFieldGet(_onModalClick, this));
        _classPrivateFieldGet(_modal, this).addEventListener('close', _classPrivateFieldGet(_onModalClose, this));
      }
      if (_classPrivateFieldGet(_searchInput, this)) {
        _classPrivateFieldGet(_searchInput, this).addEventListener('input', _classPrivateFieldGet(_onSearchInput, this));
      }
      window.addEventListener('popstate', _classPrivateFieldGet(_onPopState, this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _classPrivateFieldGet2;
      window.removeEventListener('popstate', _classPrivateFieldGet(_onPopState, this));
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_swapAbort, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.abort();
    }
  }]);
}(_wrapNativeSuper(HTMLElement));
function _openModal() {
  var _this2 = this;
  if (!_classPrivateFieldGet(_modal, this)) return;
  _classPrivateFieldSet(_lastFocusedBeforeModal, this, document.activeElement instanceof HTMLElement ? document.activeElement : null);
  document.body.style.overflow = 'hidden';
  _classPrivateFieldGet(_modal, this).showModal();
  requestAnimationFrame(function () {
    var _classPrivateFieldGet3;
    return (_classPrivateFieldGet3 = _classPrivateFieldGet(_searchInput, _this2)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.focus();
  });
}
function _closeModal() {
  var _classPrivateFieldGet4;
  (_classPrivateFieldGet4 = _classPrivateFieldGet(_modal, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.close();
}
function _filterSwatches(term) {
  if (!_classPrivateFieldGet(_modalGrid, this)) return;
  var needle = term.trim().toLowerCase();
  var swatches = _classPrivateFieldGet(_modalGrid, this).querySelectorAll('[data-fcs-modal-swatch]');
  var matchCount = 0;
  swatches.forEach(function (s) {
    var haystack = s.dataset.colorSearch || '';
    var matches = needle === '' || haystack.includes(needle);
    s.hidden = !matches;
    if (matches) matchCount += 1;
  });
  if (_classPrivateFieldGet(_modalEmpty, this)) _classPrivateFieldGet(_modalEmpty, this).hidden = matchCount > 0;
}
function _swapToSibling(_x, _x2) {
  return _swapToSibling2.apply(this, arguments);
}
function _swapToSibling2() {
  _swapToSibling2 = _asyncToGenerator(_regenerator().m(function _callee(targetUrl, clickedSwatch) {
    var _classPrivateFieldGet5,
      _classPrivateFieldGet6,
      _this3 = this;
    var section, sectionId, didTimeout, timeoutId, _newH1$textContent, _window$StampedFn, targetWithSection, response, html, fragment, newSection, cleanTarget, newH1, newProductName, sep, idx, storeSuffix, morph, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          section = this.closest('.shopify-section');
          if (section) {
            _context.n = 1;
            break;
          }
          window.location.assign(targetUrl);
          return _context.a(2);
        case 1:
          sectionId = section.id.replace(/^shopify-section-/, '');
          if (sectionId) {
            _context.n = 2;
            break;
          }
          window.location.assign(targetUrl);
          return _context.a(2);
        case 2:
          if ((_classPrivateFieldGet5 = _classPrivateFieldGet(_modal, this)) !== null && _classPrivateFieldGet5 !== void 0 && _classPrivateFieldGet5.open) _assertClassBrand(_FilamentColorSwitcher_brand, this, _closeModal).call(this);
          (_classPrivateFieldGet6 = _classPrivateFieldGet(_swapAbort, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.abort();
          _classPrivateFieldSet(_swapAbort, this, new AbortController());
          didTimeout = false;
          timeoutId = window.setTimeout(function () {
            var _classPrivateFieldGet7;
            didTimeout = true;
            (_classPrivateFieldGet7 = _classPrivateFieldGet(_swapAbort, _this3)) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.abort();
          }, 10000);
          this.classList.add('is-swapping');
          _context.p = 3;
          targetWithSection = new URL(targetUrl, window.location.origin);
          targetWithSection.searchParams.set('section_id', sectionId);
          _context.n = 4;
          return fetch(targetWithSection.toString(), {
            signal: _classPrivateFieldGet(_swapAbort, this).signal,
            headers: {
              Accept: 'text/html'
            }
          });
        case 4:
          response = _context.v;
          if (response.ok) {
            _context.n = 5;
            break;
          }
          throw new Error("Section fetch failed: ".concat(response.status));
        case 5:
          _context.n = 6;
          return response.text();
        case 6:
          html = _context.v;
          fragment = new DOMParser().parseFromString(html, 'text/html');
          newSection = fragment.getElementById(section.id);
          if (newSection) {
            _context.n = 7;
            break;
          }
          throw new Error("Section ".concat(section.id, " not found in response"));
        case 7:
          cleanTarget = new URL(targetUrl, window.location.origin);
          window.history.pushState({
            filamentColorSwitcher: true
          }, '', cleanTarget.pathname + cleanTarget.search);
          newH1 = newSection.querySelector('h1');
          newProductName = newH1 === null || newH1 === void 0 || (_newH1$textContent = newH1.textContent) === null || _newH1$textContent === void 0 ? void 0 : _newH1$textContent.trim();
          if (newProductName) {
            sep = ' \u2013 ';
            idx = document.title.indexOf(sep);
            storeSuffix = idx >= 0 ? document.title.slice(idx) : '';
            document.title = newProductName + storeSuffix;
          }
          _context.n = 8;
          return loadMorph();
        case 8:
          morph = _context.v;
          if (morph) {
            morph(section, newSection);
          } else {
            section.replaceWith(newSection);
          }
          requestAnimationFrame(function () {
            var _document$querySelect2;
            (_document$querySelect2 = document.querySelector('.filament-color-switcher__swatch.is-active')) === null || _document$querySelect2 === void 0 || _document$querySelect2.scrollIntoView({
              block: 'nearest',
              inline: 'center',
              behavior: 'instant'
            });
          });
          if (typeof ((_window$StampedFn = window.StampedFn) === null || _window$StampedFn === void 0 ? void 0 : _window$StampedFn.reloadUGC) === 'function') {
            try {
              window.StampedFn.reloadUGC();
            } catch (_) {}
          }
          window.dispatchEvent(new CustomEvent('product:section-swapped', {
            detail: {
              sectionId: section.id,
              targetUrl: targetUrl
            }
          }));
          _context.n = 11;
          break;
        case 9:
          _context.p = 9;
          _t = _context.v;
          if (!(_t.name === 'AbortError' && !didTimeout)) {
            _context.n = 10;
            break;
          }
          return _context.a(2);
        case 10:
          console.warn('[filament-color-switcher] AJAX swap failed; falling back to full navigation.', _t);
          window.location.assign(targetUrl);
        case 11:
          _context.p = 11;
          window.clearTimeout(timeoutId);
          this.classList.remove('is-swapping');
          return _context.f(11);
        case 12:
          return _context.a(2);
      }
    }, _callee, this, [[3, 9, 11, 12]]);
  }));
  return _swapToSibling2.apply(this, arguments);
}
if (!customElements.get('filament-color-switcher')) {
  customElements.define('filament-color-switcher', FilamentColorSwitcher);
}
/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-brand"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-card-footer"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-specs"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tech-spec-row"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tech-specs"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_promo-card"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

function fixPromoCardOrders() {
  var gridsWithPromos = new Map();
  document.querySelectorAll('[data-promo-card]').forEach(function (promo) {
    var grid = promo.parentElement;
    if (!grid) return;
    if (!gridsWithPromos.has(grid)) gridsWithPromos.set(grid, []);
    gridsWithPromos.get(grid).push(promo);
  });
  gridsWithPromos.forEach(function (promos) {
    if (promos.length < 2) return;
    promos.sort(function (a, b) {
      return Number(a.dataset.promoPosition) - Number(b.dataset.promoPosition);
    }).forEach(function (promo, index) {
      var position = Number(promo.dataset.promoPosition);
      if (!Number.isFinite(position)) return;
      var effectiveSlot = position - index;
      promo.style.order = effectiveSlot * 2 - 1;
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixPromoCardOrders, {
    once: false
  });
} else {
  fixPromoCardOrders();
}
document.addEventListener('shopify:block:select', fixPromoCardOrders);
document.addEventListener('shopify:block:deselect', fixPromoCardOrders);
document.addEventListener('shopify:section:load', fixPromoCardOrders);
/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

var morphPromise = null;
var loadMorph = function loadMorph() {
  if (!morphPromise) {
    morphPromise = new Function("return import('@theme/morph')")().then(function (mod) {
      return mod.morph;
    }).catch(function () {
      return null;
    });
  }
  return morphPromise;
};
var THEME_EVENT = {
  variantUpdate: 'variant:update',
  variantSelected: 'variant:selected',
  quantitySelectorUpdate: 'quantity-selector:update'
};
var _stickyBar = new WeakMap();
var _addToCartButton = new WeakMap();
var _quantityDisplay = new WeakMap();
var _quantityNumber = new WeakMap();
var _buyButtonsObserver = new WeakMap();
var _footerObserver = new WeakMap();
var _abortController = new WeakMap();
var _targetAddToCartButton = new WeakMap();
var _currentQuantity = new WeakMap();
var _isStuck = new WeakMap();
var _hiddenByBottom = new WeakMap();
var _sectionId = new WeakMap();
var _StickyAddToCart_brand = new WeakSet();
var _handleAddToCartClick = new WeakMap();
var _handleVariantUpdate = new WeakMap();
var _handleVariantSelected = new WeakMap();
var _handleQuantityUpdate = new WeakMap();
var StickyAddToCart = function (_HTMLElement) {
  function StickyAddToCart() {
    var _this;
    _classCallCheck(this, StickyAddToCart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StickyAddToCart, [].concat(args));
    _classPrivateMethodInitSpec(_this, _StickyAddToCart_brand);
    _classPrivateFieldInitSpec(_this, _stickyBar, null);
    _classPrivateFieldInitSpec(_this, _addToCartButton, null);
    _classPrivateFieldInitSpec(_this, _quantityDisplay, null);
    _classPrivateFieldInitSpec(_this, _quantityNumber, null);
    _classPrivateFieldInitSpec(_this, _buyButtonsObserver, null);
    _classPrivateFieldInitSpec(_this, _footerObserver, null);
    _classPrivateFieldInitSpec(_this, _abortController, new AbortController());
    _classPrivateFieldInitSpec(_this, _targetAddToCartButton, null);
    _classPrivateFieldInitSpec(_this, _currentQuantity, 1);
    _classPrivateFieldInitSpec(_this, _isStuck, false);
    _classPrivateFieldInitSpec(_this, _hiddenByBottom, false);
    _classPrivateFieldInitSpec(_this, _sectionId, null);
    _classPrivateFieldInitSpec(_this, _handleAddToCartClick, function () {
      if (!_classPrivateFieldGet(_targetAddToCartButton, _this)) return;
      _classPrivateFieldGet(_targetAddToCartButton, _this).click();
    });
    _classPrivateFieldInitSpec(_this, _handleVariantUpdate, function () {
      var _ref = _asyncToGenerator(_regenerator().m(function _callee(event) {
        var _event$detail, _event$detail$data$ht, _event$detail$data$ht2, _classPrivateFieldGet3;
        var newStickyAddToCart, newStickyBar, morph, currentStuck, variantAvailable, _classPrivateFieldGet2, signal, variant, productForm;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(((_event$detail = event.detail) === null || _event$detail === void 0 || (_event$detail = _event$detail.data) === null || _event$detail === void 0 ? void 0 : _event$detail.productId) !== _this.dataset.productId)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              newStickyAddToCart = (_event$detail$data$ht = event.detail.data.html) === null || _event$detail$data$ht === void 0 || (_event$detail$data$ht2 = _event$detail$data$ht.querySelector) === null || _event$detail$data$ht2 === void 0 ? void 0 : _event$detail$data$ht2.call(_event$detail$data$ht, 'sticky-add-to-cart');
              if (newStickyAddToCart) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              newStickyBar = newStickyAddToCart.querySelector('[ref="stickyBar"]');
              if (newStickyBar) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 4;
              return loadMorph();
            case 4:
              morph = _context.v;
              if (!(!morph || !_classPrivateFieldGet(_stickyBar, _this))) {
                _context.n = 5;
                break;
              }
              return _context.a(2);
            case 5:
              currentStuck = _classPrivateFieldGet(_stickyBar, _this).getAttribute('data-stuck') || 'false';
              variantAvailable = newStickyAddToCart.dataset.variantAvailable;
              morph(_classPrivateFieldGet(_stickyBar, _this), newStickyBar, {
                childrenOnly: true
              });
              _classPrivateFieldSet(_addToCartButton, _this, _this.querySelector('[ref="addToCartButton"]'));
              _classPrivateFieldSet(_quantityDisplay, _this, _this.querySelector('[ref="quantityDisplay"]'));
              _classPrivateFieldSet(_quantityNumber, _this, _this.querySelector('[ref="quantityNumber"]'));
              _classPrivateFieldGet(_abortController, _this).abort();
              _classPrivateFieldSet(_abortController, _this, new AbortController());
              _classPrivateFieldGet2 = _classPrivateFieldGet(_abortController, _this), signal = _classPrivateFieldGet2.signal;
              (_classPrivateFieldGet3 = _classPrivateFieldGet(_addToCartButton, _this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.addEventListener('click', _classPrivateFieldGet(_handleAddToCartClick, _this), {
                signal: signal
              });
              document.addEventListener(THEME_EVENT.variantUpdate, _classPrivateFieldGet(_handleVariantUpdate, _this), {
                signal: signal
              });
              document.addEventListener(THEME_EVENT.variantSelected, _classPrivateFieldGet(_handleVariantSelected, _this), {
                signal: signal
              });
              document.addEventListener(THEME_EVENT.quantitySelectorUpdate, _classPrivateFieldGet(_handleQuantityUpdate, _this), {
                signal: signal
              });
              _classPrivateFieldGet(_stickyBar, _this).setAttribute('data-stuck', currentStuck);
              _this.dataset.variantAvailable = variantAvailable;
              variant = event.detail.resource;
              if (variant !== null && variant !== void 0 && variant.id) _this.dataset.currentVariantId = variant.id;
              productForm = _assertClassBrand(_StickyAddToCart_brand, _this, _getProductForm).call(_this);
              if (productForm) {
                _classPrivateFieldSet(_targetAddToCartButton, _this, productForm.querySelector('[ref="addToCartButton"]'));
              }
              _assertClassBrand(_StickyAddToCart_brand, _this, _updateButtonText).call(_this);
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _classPrivateFieldInitSpec(_this, _handleVariantSelected, function (event) {
      var _event$detail2;
      var variantId = (_event$detail2 = event.detail) === null || _event$detail2 === void 0 || (_event$detail2 = _event$detail2.resource) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.id;
      if (!variantId) return;
      _this.dataset.currentVariantId = variantId;
    });
    _classPrivateFieldInitSpec(_this, _handleQuantityUpdate, function (event) {
      var _event$detail3, _event$detail$quantit, _event$detail4;
      if ((_event$detail3 = event.detail) !== null && _event$detail3 !== void 0 && _event$detail3.cartLine) return;
      _classPrivateFieldSet(_currentQuantity, _this, (_event$detail$quantit = (_event$detail4 = event.detail) === null || _event$detail4 === void 0 ? void 0 : _event$detail4.quantity) !== null && _event$detail$quantit !== void 0 ? _event$detail$quantit : _classPrivateFieldGet(_currentQuantity, _this));
      _assertClassBrand(_StickyAddToCart_brand, _this, _updateButtonText).call(_this);
    });
    return _this;
  }
  _inherits(StickyAddToCart, _HTMLElement);
  return _createClass(StickyAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.dataset.portaled !== 'true') {
        var _sectionElement$id$re, _sectionElement$id;
        var sectionElement = this.closest('.shopify-section');
        _classPrivateFieldSet(_sectionId, this, (_sectionElement$id$re = sectionElement === null || sectionElement === void 0 || (_sectionElement$id = sectionElement.id) === null || _sectionElement$id === void 0 ? void 0 : _sectionElement$id.replace('shopify-section-', '')) !== null && _sectionElement$id$re !== void 0 ? _sectionElement$id$re : null);
        this.dataset.portaled = 'true';
        document.body.appendChild(this);
        return;
      }
      _classPrivateFieldSet(_stickyBar, this, this.querySelector('[ref="stickyBar"]'));
      _classPrivateFieldSet(_addToCartButton, this, this.querySelector('[ref="addToCartButton"]'));
      _classPrivateFieldSet(_quantityDisplay, this, this.querySelector('[ref="quantityDisplay"]'));
      _classPrivateFieldSet(_quantityNumber, this, this.querySelector('[ref="quantityNumber"]'));
      if (!_classPrivateFieldGet(_stickyBar, this) || !_classPrivateFieldGet(_addToCartButton, this)) return;
      if (_classPrivateFieldGet(_abortController, this).signal.aborted) {
        _classPrivateFieldSet(_abortController, this, new AbortController());
      }
      var _classPrivateFieldGet4 = _classPrivateFieldGet(_abortController, this),
        signal = _classPrivateFieldGet4.signal;
      _classPrivateFieldGet(_addToCartButton, this).addEventListener('click', _classPrivateFieldGet(_handleAddToCartClick, this), {
        signal: signal
      });
      _assertClassBrand(_StickyAddToCart_brand, this, _setupObservers).call(this);
      document.addEventListener(THEME_EVENT.variantUpdate, _classPrivateFieldGet(_handleVariantUpdate, this), {
        signal: signal
      });
      document.addEventListener(THEME_EVENT.variantSelected, _classPrivateFieldGet(_handleVariantSelected, this), {
        signal: signal
      });
      document.addEventListener(THEME_EVENT.quantitySelectorUpdate, _classPrivateFieldGet(_handleQuantityUpdate, this), {
        signal: signal
      });
      _assertClassBrand(_StickyAddToCart_brand, this, _getInitialQuantity).call(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _classPrivateFieldGet5, _classPrivateFieldGet6;
      (_classPrivateFieldGet5 = _classPrivateFieldGet(_buyButtonsObserver, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.disconnect();
      (_classPrivateFieldGet6 = _classPrivateFieldGet(_footerObserver, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.disconnect();
      _classPrivateFieldGet(_abortController, this).abort();
    }
  }]);
}(_wrapNativeSuper(HTMLElement));
function _setupObservers() {
  var _document$querySelect,
    _this2 = this;
  var productForm = _assertClassBrand(_StickyAddToCart_brand, this, _getProductForm).call(this);
  if (!productForm) return;
  var buyButtonsBlock = productForm.closest('.buy-buttons-block');
  if (!buyButtonsBlock) return;
  var footer = (_document$querySelect = document.querySelector('footer')) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.querySelector('[class*="footer-group"]');
  if (!footer) return;
  _classPrivateFieldSet(_buyButtonsObserver, this, new IntersectionObserver(function (entries) {
    var _entries = _slicedToArray(entries, 1),
      entry = _entries[0];
    if (!entry) return;
    if (!entry.isIntersecting && !_classPrivateFieldGet(_isStuck, _this2)) {
      var rect = entry.target.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top < 0) {
        _assertClassBrand(_StickyAddToCart_brand, _this2, _showStickyBar).call(_this2);
      }
    } else if (entry.isIntersecting && _classPrivateFieldGet(_isStuck, _this2)) {
      _classPrivateFieldSet(_hiddenByBottom, _this2, false);
      _assertClassBrand(_StickyAddToCart_brand, _this2, _hideStickyBar).call(_this2);
    }
  }));
  _classPrivateFieldSet(_footerObserver, this, new IntersectionObserver(function (entries) {
    var _entries2 = _slicedToArray(entries, 1),
      entry = _entries2[0];
    if (!entry) return;
    if (entry.isIntersecting && _classPrivateFieldGet(_isStuck, _this2)) {
      _classPrivateFieldSet(_hiddenByBottom, _this2, true);
      _assertClassBrand(_StickyAddToCart_brand, _this2, _hideStickyBar).call(_this2);
    } else if (!entry.isIntersecting && _classPrivateFieldGet(_hiddenByBottom, _this2)) {
      var rect = buyButtonsBlock.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top < 0) {
        _classPrivateFieldSet(_hiddenByBottom, _this2, false);
        _assertClassBrand(_StickyAddToCart_brand, _this2, _showStickyBar).call(_this2);
      }
    }
  }, {
    rootMargin: '200px 0px 0px 0px'
  }));
  _classPrivateFieldGet(_buyButtonsObserver, this).observe(buyButtonsBlock);
  _classPrivateFieldGet(_footerObserver, this).observe(footer);
  _classPrivateFieldSet(_targetAddToCartButton, this, productForm.querySelector('[ref="addToCartButton"]'));
}
function _showStickyBar() {
  if (!_classPrivateFieldGet(_stickyBar, this)) return;
  _classPrivateFieldSet(_isStuck, this, true);
  _classPrivateFieldGet(_stickyBar, this).dataset.stuck = 'true';
}
function _hideStickyBar() {
  if (!_classPrivateFieldGet(_stickyBar, this)) return;
  _classPrivateFieldSet(_isStuck, this, false);
  _classPrivateFieldGet(_stickyBar, this).dataset.stuck = 'false';
}
function _getProductForm() {
  var productId = this.dataset.productId;
  if (!productId || !_classPrivateFieldGet(_sectionId, this)) return null;
  return document.querySelector("#shopify-section-".concat(_classPrivateFieldGet(_sectionId, this), " product-form-component[data-product-id=\"").concat(productId, "\"]"));
}
function _getInitialQuantity() {
  _classPrivateFieldSet(_currentQuantity, this, parseInt(this.dataset.initialQuantity || '1', 10) || 1);
  _assertClassBrand(_StickyAddToCart_brand, this, _updateButtonText).call(this);
}
function _updateButtonText() {
  if (!_classPrivateFieldGet(_addToCartButton, this) || !_classPrivateFieldGet(_quantityDisplay, this) || !_classPrivateFieldGet(_quantityNumber, this)) return;
  var available = !_classPrivateFieldGet(_addToCartButton, this).disabled;
  _classPrivateFieldGet(_quantityNumber, this).textContent = _classPrivateFieldGet(_currentQuantity, this).toString();
  _classPrivateFieldGet(_quantityDisplay, this).style.display = available && _classPrivateFieldGet(_currentQuantity, this) > 1 ? 'inline' : 'none';
}
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compatible-printers-chips"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-sku"] && !Shopify.designMode) return;
  try {
    /******/ (function() { // webpackBootstrap
/******/ 	"use strict";

/******/ })()
;
  } catch(e) { console.error(e); }
})();

})();
